// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav.menu-lateral {
    width: 80px;
    height: 100%;
    margin-top: calc(100vh / 10);
    background-color: #012267;
    padding: 10px 0 40px 1%;
    box-shadow: 3px 0 0 #f79c17;
    position: fixed;
   
    left: 0;
    overflow: hidden;
    transition: .5s;
    margin-left: -40px;
}

nav.menu-lateral.expandir{
    width: 300px;
} 

.btn-expandir {
    width: 100%;
    padding-left: 40px;
}

.btn-expandir>i {
    color: #f79c17;
    font-size: 20px;
    cursor: pointer;
}

ul.menu-lateral-itens {
    height: 100%;
    list-style-type: none;
}

ul li.item-menu {
    transition: .2s;
}

.linkAtivo {
    background-color: #6c62f7;
}


ul li.item-menu:hover {
    background-color: #6c62f7;

}

ul li.item-menu a {
    color: #f79c17;
    text-decoration: none;
    font-size: 20px;
    padding: 0px 2%;
    display: flex;
    margin-bottom: 10px;
    line-height: 30px;
}

ul li.item-menu a .txt-link {
    transition: .5s;
    font-size: 1px;
    opacity: 0;
    line-height: 0px;
}
nav.menu-lateral.expandir .txt-link {
    margin-left: 20px;
    font-size: 20px;
    opacity: 1;
    line-height: 30px;
}

ul li.item-menu a .icon>i {
    font-size: 30px;
    margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/componentes/MenuLateral/estilo.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,yBAAyB;IACzB,uBAAuB;IACvB,2BAA2B;IAC3B,eAAe;;IAEf,OAAO;IACP,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":["nav.menu-lateral {\r\n    width: 80px;\r\n    height: 100%;\r\n    margin-top: calc(100vh / 10);\r\n    background-color: #012267;\r\n    padding: 10px 0 40px 1%;\r\n    box-shadow: 3px 0 0 #f79c17;\r\n    position: fixed;\r\n   \r\n    left: 0;\r\n    overflow: hidden;\r\n    transition: .5s;\r\n    margin-left: -40px;\r\n}\r\n\r\nnav.menu-lateral.expandir{\r\n    width: 300px;\r\n} \r\n\r\n.btn-expandir {\r\n    width: 100%;\r\n    padding-left: 40px;\r\n}\r\n\r\n.btn-expandir>i {\r\n    color: #f79c17;\r\n    font-size: 20px;\r\n    cursor: pointer;\r\n}\r\n\r\nul.menu-lateral-itens {\r\n    height: 100%;\r\n    list-style-type: none;\r\n}\r\n\r\nul li.item-menu {\r\n    transition: .2s;\r\n}\r\n\r\n.linkAtivo {\r\n    background-color: #6c62f7;\r\n}\r\n\r\n\r\nul li.item-menu:hover {\r\n    background-color: #6c62f7;\r\n\r\n}\r\n\r\nul li.item-menu a {\r\n    color: #f79c17;\r\n    text-decoration: none;\r\n    font-size: 20px;\r\n    padding: 0px 2%;\r\n    display: flex;\r\n    margin-bottom: 10px;\r\n    line-height: 30px;\r\n}\r\n\r\nul li.item-menu a .txt-link {\r\n    transition: .5s;\r\n    font-size: 1px;\r\n    opacity: 0;\r\n    line-height: 0px;\r\n}\r\nnav.menu-lateral.expandir .txt-link {\r\n    margin-left: 20px;\r\n    font-size: 20px;\r\n    opacity: 1;\r\n    line-height: 30px;\r\n}\r\n\r\nul li.item-menu a .icon>i {\r\n    font-size: 30px;\r\n    margin-left: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
